<mat-form-field floatLabel="always" class="textbox"
  [style]="textArea.inlineStyle ? layoutElemeneUtil.translateStyle(textArea.inlineStyle):''"
  appearance="outline">
  <button (click)="fireCopyEvent($event)">Daten &Uuml;bernehmen</button>
  <mat-label class="custom-form-caption-label">{{ textArea.caption }}</mat-label>
  <textarea [(ngModel)]="textArea.content"
    [maxlength]="textArea.maxChars === 0 ? null : textArea.maxChars!"
    [rows]="textArea.rows" [disabled]="layoutElemeneUtil.ReadonlyMode"
    (ngModelChange)="fire($event)"

  matInput></textarea>
  @if (textArea.maxCharsWarning && textArea.maxChars) {
    <app-character-counter
      [maxChars]="textArea.maxChars"
      [maxCharsWarning]="textArea.maxCharsWarning"
      [charSequenceLength]="textArea!.content!.length"
    [isArdPopnacht]="textArea.isArdPopnacht"></app-character-counter>
  }
</mat-form-field>
